import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import { getFrameStyleOptions } from '../../../helpers/frameStyle';
import { isCurrentState } from '../../../helpers/isCurrentState';
import { throwError } from '../../../helpers/throwError';
import { ProductBuilderMachineEvent } from '../../../types';
import { Heading } from '../../Common/Heading';
import {
  Selector,
  SelectorItem,
  SelectorImageItem,
} from '../../Common/Selector';
import { SectionContent } from './SectionContent';
import { getProductStateConfig } from '../../../helpers/getProductStateConfig';
import { getBaseProductType } from '../../../helpers/getBaseProductType';
import { Caption } from '../../Common/Caption';

type OnClick = (
  frameStyle: string,
  send: (event: ProductBuilderMachineEvent) => void,
) => () => void;

const onClick: OnClick = (frameStyle, send) => () => {
  send({
    type: 'UPDATE_CUSTOM',
    custom: {
      frameStyle,
    },
  });
};

export const FrameStyle = () => {
  const [state, send] = useService(productBuilderMachine);
  const {
    custom: { frameStyle },
  } = state.context;
  const frameStyleOptions = getFrameStyleOptions(state.context);
  const productType = getBaseProductType(state.context);

  if (isCurrentState('frameStyle', state) && frameStyleOptions.length === 0) {
    throwError(state);
  }

  return (
    <SectionContent>
      <Heading>Frame Style</Heading>
      <Selector isSlider={true}>
        {frameStyleOptions.map(option => {
          const { showIcon, Icon, description } = getProductStateConfig(
            productType,
            'frameStyle',
            option,
          );
          return (
            <SelectorImageItem
              isSelected={option === frameStyle}
              onClick={onClick(option, send)}
              showIcon={showIcon}
              Icon={Icon}
              title={option}
              key={option}
              description={description}
            />
          );
        })}
      </Selector>
    </SectionContent>
  );
};
